import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import { useAccountsDomain } from 'services/accounts/accounts_domain';

import { usePangolinDomain } from 'services/pangolin/pangolin_domain';
import { scheduleCreate } from 'services/pangolin/schedule_service';

import { Redirect } from 'pages/core/redirect/redirect';

import { BaseEditSchedule } from './edit_schedule';

export const CreateSchedule = observer(() => {
  const { pangolinID } = useParams<{ pangolinID: string }>();
  if (!pangolinID) return <Redirect />;

  const accounts = useAccountsDomain();

  const pangolin = accounts.pangolins.get(pangolinID);
  if (!pangolin) return <Redirect />;

  const domain = usePangolinDomain(pangolin.id);
  if (!domain) return <Redirect />;

  const schedule = scheduleCreate();

  return (
    <BaseEditSchedule
      pangolin={pangolin}
      domain={domain}
      schedule={schedule}
    />
  );
});
